// store/slices/appSlice.js
import { createSlice } from '@reduxjs/toolkit';

const appSlice = createSlice({
  name: 'app',
  initialState: { isAppReady: false },
  reducers: {
    setAppReady(state) {
      state.isAppReady = true;
    },
  },
});

export const { setAppReady } = appSlice.actions;
export default appSlice.reducer;